import * as HTMLService from './html_service';

export { HTMLService };
